module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKsc-Bold.e3f19cbf.otf";